import { EditIcon } from '@navi/web-ui/lib/icons';
import { Button, Drawer, Typography } from '@navi/web-ui/lib/primitives';

interface ViewAgentDrawerProps {
  isDrawerOpen: boolean;
  onClose: () => void;
  toggleEditState: () => void;
  section?: JSX.Element;
  setShowLoader?: (value: boolean) => void;
}

const ViewAgentDrawer = (props: ViewAgentDrawerProps) => {
  const { isDrawerOpen, onClose, toggleEditState, section, setShowLoader } = props;

  const handleButtonClick = () => {
    setShowLoader && setShowLoader(true);
    toggleEditState();
  };
  return (
    <>
      <Drawer
        open={isDrawerOpen}
        onClose={onClose}
        headerText={
          <div className="flex gap-40">
            <Typography variant="h3">View details</Typography>
            <div>
              <Button variant="text" onClick={handleButtonClick}>
                <div className="ml-8 flex items-center gap-2">
                  <EditIcon color="var(--navi-color-blue-base)" size="sm" />
                  <Typography variant="h3" color="var(--navi-color-blue-base)">
                    Edit
                  </Typography>
                </div>
              </Button>
            </div>
          </div>
        }
        showHeaderDivider={true}
        usePadding={false}
        style={{ width: '400px' }}
        contentClasses="overflow-auto"
      >
        <div>
          <section>{section}</section>
        </div>
      </Drawer>
    </>
  );
};

export default ViewAgentDrawer;
